module.exports = __webpack_public_path__ + "static/media/molar-with-cavity.604244ed.svg";